import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

export const UserQuerySchema = PaginationRequestSchema.extend({
  search: z.string().optional(),
  email: z.string().optional(),
  username: z.string().optional(),
  userTag: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  state: z.string().optional(),
  createdFrom: z.string().optional(),  
  createdTo: z.string().optional(),
});
export type UserQueryDTO = z.infer<typeof UserQuerySchema>;

// Register Request
export const RegisterRequestSchema = z.object({
  email: z.email("Email inválido"),
  username: z.string().min(1, "El username es requerido"),
  password: z
    .string()
    .min(8, "La contraseña debe tener al menos 8 caracteres")
    .regex(/[0-9]/, "La contraseña debe contener al menos un número")
    .regex(/[a-zA-Z]/, "La contraseña debe contener al menos una letra")
    .regex(
      /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]/,
      "La contraseña debe contener al menos un caracter especial"
    ),
  firstName: z.string().min(1, "El nombre es requerido"),
  lastName: z.string().min(1, "El apellido es requerido"),
  secondName: z.string().optional(),
  secondLastName: z.string().optional(),
  phone: z.string().optional(),
  dni: z.string().optional(),
});

export const UpdateUserRequestSchema = z.object({
  email: z.email("Email inválido"),
  username: z.string().optional(),
  firstName: z.string().min(1, "El nombre es requerido"),
  lastName: z.string().min(1, "El apellido es requerido"),
  secondName: z.string().optional(),
  secondLastName: z.string().optional(),
  phone: z.string().optional(),
  dni: z.string().optional(),
});
export type UpdateUserRequestDTO = z.infer<typeof UpdateUserRequestSchema>;
export type RegisterRequestDTO = z.infer<typeof RegisterRequestSchema>;

// Register Response
export const UserResponseSchema = z.object({
  id: z.string(),
  email: z.string(),
  username: z.string().optional(),
  userTag: z.string().optional(),
  firstName: z.string(),
  lastName: z.string(),
  secondName: z.string().optional(),
  secondLastName: z.string().optional(),
  phone: z.string().optional(),
  dni: z.string().optional(),
  fullName: z.string(),
  state: z.string(),
  createdAt: z.coerce.date(),
});

export type UserResponseDTO = z.infer<typeof UserResponseSchema>;

// Paginated Users Response
export const UsersPaginatedResponseSchema = PaginationResponseSchema(
  UserResponseSchema
);
export type UsersPaginatedResponseDTO = z.infer<typeof UsersPaginatedResponseSchema>;

